export const platformRoleError = (error: unknown): string => {
  const e = error as { status?: number | string; data?: { details?: { errorCode?: string }; statusCode?: number } };
  const code = e?.data?.details?.errorCode;
  if (code === 'PLR001') return 'Keep another eligible administrator before revoking this role, deactivating or deleting this administrator.';
  const messages: Record<string, string> = {
    PLR002: 'Enter a valid user ID.', PLR003: 'Choose a role from the current catalog.',
    PLR004: 'Enter a non-empty reason of at most 1000 characters.',
    PLR005: 'The request identifier is invalid. Refresh and retry.',
    PLR006: 'Page size must be between 1 and 200.',
    PLR007: 'The page cursor is invalid. Return to the first page.',
  };
  if (code && messages[code]) return messages[code];
  if (e?.status === 403) return 'Your current session cannot perform this action.';
  if (e?.status === 404) return 'This user no longer exists or is unavailable.';
  return 'The operation failed. Refresh the data and check your access before retrying.';
};
